<template>
  <section class="message__question">
    <slot />
    <div v-html="content" />
    <TransitionExpand>
      <div
        v-if="showOptions"
        class="message__options"
        v-html="optionsFormatted"
      />
    </TransitionExpand>
    <span class="message__collapse" @click="collapseOptions">{{
      labelCollapse
    }}</span>
  </section>
</template>

<script>
import { TransitionExpand } from '@/components/shared/atoms'
export default {
  components: { TransitionExpand },
  props: {
    content: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showOptions: false
    }
  },
  computed: {
    optionsFormatted() {
      return this.options.map(option => '&bull; ' + option.label).join('</br>')
    },
    labelCollapse() {
      return this.showOptions ? 'Ocultar opções' : 'Mostrar opções'
    }
  },
  methods: {
    collapseOptions() {
      this.showOptions = !this.showOptions
    }
  }
}
</script>

<style lang="scss">
.message__question {
  max-width: max-content;

  .message__options {
    margin-top: var(--gl-spacing-06);
  }
  .message__collapse {
    cursor: pointer;
    color: var(--sys-color-surface-container-active-variant);
    margin-top: var(--gl-spacing-01);
  }
}
</style>
